<button
  *ngIf="!isStroked"
  [type]="type"
  mat-raised-button
  [color]="color"
  [disabled]="disabled || saving"
  [ngClass]="buttonClass"
>
  <div class="button-content">
    <mat-spinner
      *ngIf="saving"
      diameter="18"
      class="button-spinner"
    ></mat-spinner>
    <mat-icon *ngIf="icon && !saving" class="small-icon">{{ icon }}</mat-icon>
    <span>{{ (saving ? 'SavingWithThreeDots' : title) | localize }}</span>
  </div>
</button>

<button
  *ngIf="isStroked"
  [type]="type"
  mat-stroked-button
  [color]="color"
  [disabled]="disabled || saving"
  [ngClass]="buttonClass"
>
  <div class="button-content">
    <mat-spinner
      *ngIf="saving"
      diameter="18"
      class="button-spinner"
    ></mat-spinner>
    <mat-icon *ngIf="icon && !saving" class="small-icon">{{ icon }}</mat-icon>
    <span>{{ (saving ? 'SavingWithThreeDots' : title) | localize }}</span>
  </div>
</button>
